// import logo from './logo.svg';
// import './App.css';
import MovingCircle from "./MovingCircle";


function App() {
  return (
    <div style={{
      background: "black",
      height: "100vh",
      overflow: "hidden",
      position: "relative",
      color: "white",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontSize: "3rem"
    }}>
      content will follow soon 
      <MovingCircle />
    </div>
  );
}

export default App;

